export default __webpack_public_path__ + "static/media/robot.3dfeda24.gif";